<div class="db-main-header-content {{(createAiAssistantService.hideOnboardingBackButton|async)}}" *ngIf="(isMobile && ['setup', 'setup-onboarding',
'fill-company-info', 'filled-company-info', 'ai-demo', 'start-ai-website-building', 'v2-ai-website-building',
'mobile-sign-up', 'builder-v2', 'mobile-sign-up-email', 'fill-products'].includes(pageId)) &&
![builderStep?.SHOW_HERO].includes(_builderHistoryService.builderStep|async)">
  <div class="db-header-back-button" (click)="back()"
       *ngIf="!['setup', 'setup-onboarding', 'domain-search', 'filled-company-info'].includes(pageId) && !(createAiAssistantService.hideOnboardingBackButton|async) && !hideBackButton &&
       !fromAiCreate
       && ![builderStep.SHOW_FINALIZE].includes(_builderHistoryService.builderStep|async)">
    <i class="db-icon db-icon-ds-arrow-small"></i>
      <span>back</span>
  </div>
</div>

<div class="navigation-container" *ngIf="!isMobile && ['setup', 'setup-onboarding'].includes(pageId)">
    <img [src]="_builderSectionsInteractionsService?.companyInfo?.value?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'" />
</div>

<db-question-step *ngIf="signUpForStep" @slideLeftLeave [signUpForAnswers]="signUpForAnswers" [userSubscription]="currentSubscription" [boosterClient]="currentSubscription?.trialBoosterClient" [userLocalStorage]="userLocalStorage" (closeSignUpForStep)="closeSignUpForStep()"></db-question-step>

<db-connect-and-optimize *ngIf="!signUpForStep && photoGalleryPluginIds.includes(currentSubscription?.product_id)" [email]="user?.email" @slideLeftEnter></db-connect-and-optimize>

<div class="db-setup" [ngClass]="{'center-on-xxl': pageId === 'setup-onboarding' || pageId === 'setup', 'full-height': (_builderHistoryService.builderStep|async) === builderSteps.SHOW_CANVAS}"
     *ngIf="!signUpForStep && !currentSubscription?.trialBoosterClient && !photoGalleryPluginIds.includes(currentSubscription?.product_id)" @slideLeftEnter>
  <div class="db-setup-wrap" *ngIf="[ 'setup', 'setup-onboarding'].includes(pageId)">
    <div class="db-setup-wrap-header-name">
      <img src="assets/images/illustrations/setup/waving-hand.svg" alt=""/>
      <span>Hey {{user ? user?.firstName : 'there'}}!</span>
    </div>
    <div class="db-setup-wrap-title">{{'text_setupTitle' | dbText}}</div>
    <div class="db-setup-wrap-desc">{{'text_setupDesc' | dbText}}</div>
    <div class="db-setup-wrap-blocks">
      <div class="db-setup-wrap-block-item"
           *ngFor="let block of blocks" (click)="goToNextStep(!user ? block.secondUrl ? block.secondUrl :  block.url :  block.url,  block.gaAction, !user ? block?.gaActionNoUser : null )">
        <div class="db-setup-wrap-block-img">
          <span class="db-img-title">{{block?.imgTitle}}</span>
          <i class="db-icon db-icon-{{block?.icon}}"></i>
        </div>
        <div class="db-setup-wrap-block-title" [innerHtml]="block.title | dbText"></div>
        <div class="db-setup-wrap-block-desc" [innerHtml]="block.desc | dbText"></div>
        <div class="db-setup-wrap-block-button" *ngIf="!isMobile">
          <a class="ds-btn-black"><span [innerHTML]="'text_proceed' | dbText"></span></a>
        </div>
      </div>
    </div>
    <a class="ds-link" (click)="goToNextStep('install-blank', 'Create a Website with Install Blank', !user ? 'Blank Website' : null)"><span>Or install a blank WordPress website</span></a>
  </div>
  <div class="db-onboarding-router-wrap"  *ngIf="pageId !== 'setup' && pageId !== 'setup-onboarding'"><router-outlet></router-outlet></div>
</div>

